import { render, staticRenderFns } from "./RegistroPreaspirante.vue?vue&type=template&id=35b4b95e"
import script from "./RegistroPreaspirante.vue?vue&type=script&lang=js"
export * from "./RegistroPreaspirante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports